import React from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
const DataPrivacy = () => {
  const navigate = useNavigate();
  const navigateToHome = () => {
    navigate("/");
  };
  return (
    <>
      <br></br>
      <br></br>
      <h1 style={{color: 'black'}}>Adatvédelmi tájékoztató</h1>
      <p>
        Ez az adatvédelmi tájékoztató részletes információkat nyújt az [VÁLLALAT
        NEVE] által végzett személyes adatok kezeléséről.
      </p>
      <h2> Bevezetés és általános információk</h2>
      <ul>
        <li>
          <strong>Vállalkozás neve:</strong> [VÁLLALAT NEVE]
        </li>
        <li>
          <strong>Elérhetőségek:</strong> [ELÉRHETŐSÉGEK]
        </li>
        <li>
          <strong>Adatkezelési nyilatkozat hatálya és érvényessége:</strong>{" "}
          [HATÁLY ÉRVÉNYESSÉG]
        </li>
      </ul>
      <h2> Adatkezelés célja</h2>
      <p>
        Az adatkezelés célja az érintettek azonosítása és felhasználói fiókok
        létrehozása érdekében, valamint a munkaadók szempontjából a felhasználók
        közötti összekötés lehetőségének biztosítása.
      </p>
      <h2>Gyűjtött adatok típusa</h2>
      <ul>
        <li>
          <strong>Gyűjtve szerezhető adatok:</strong> Név, e-mail cím,
          telefonszám, önkéntesen megadott önéletrajz szerű adatok a felhasználó képesítéseiről és jogosítványairól, munkával kapcsolatos
          preferenciák tárolása
        </li>
      </ul>
      <h2> Adatkezelés jogalapja</h2>
      <p>
        A személyes adatok kezelése az érintettek önkéntes hozzájárulásán és a
        felhasználói fiókok létrehozásához szükséges jogalappal történik.
      </p>
      <h2> Adattovábbítás</h2>
      <p>
        Az adatokat kizárólag az [VÁLLALAT NEVE] és az oldalra regisztrált
        munkaadóinak csoportjának tagjai részére továbbíthatjuk, akik kötelesek
        titoktartást vállalni. Az adattovábbításnak megfelelő jogi alapja és
        indokoltnak kell lennie.
      </p>
      <h2>Adatvédelem és biztonság</h2>
      <p>
        A vállalkozás technológiailag legfrissebb eszközöket alkalmaz az
        adatvédelem érdekében. Megtesz minden olyan intézkedést, amely az adatok
        biztonságát garantálja, beleértve a fizikai és logikai védelmi
        intézkedéseket, valamint a hozzáférés-ellenőrzést.
      </p>
      <h2>Érintettek jogai</h2>
      <ul>
        <li>
          <strong>Adattörlés:</strong> A cég elérhetőségein keresztül
          lehetőséget kapnak az adataik törlésére.
        </li>
        <li>
          <strong>Adatmódosítás:</strong> Az adataik módosítása is lehetséges
          ugyancsak a cég elérhetőségein keresztül.
        </li>
        <li>
          <strong>Adatlekérés:</strong> A cég elérhetőségein keresztül
          lehetőséget kapnak az adataik lekérésére.
        </li>
      </ul>
      <h2>Sütik és online nyomkövetés</h2>
      <p>
        A vállalkozás sütikben gyűjti és tárolja a regisztrált/bejelentkezett felhasználó név és profilképét, valamint e-mail címet tárol sütikben az
        egyszerűbb hozzáférések érdekében. Ezeket nem osztjuk meg harmadik
        felekkel vagy továbbítjuk más weboldalakra soha. Kizárólagos felhasználási célja a felhasználó autmatikus bejelentkeztetése. A sütiket maximum 24 óráig lehet felhasználni, utána újabb bejelentkezés szükséges.
      </p>
      <h2> Cégadatok és kapcsolattartás</h2>
      <p>
        A cég adatvédelmi felelőse: [CÉG ADATVEDELMI FELELŐSE]. A
        kapcsolattartás során kereshetnek bennünket a [VÁLLALAT NEVE]
        elérhetőségein keresztül.
      </p>
      <h2> Frissítések és változtatások</h2>
      <p>
        A tájékoztató időnként frissülhet. Minden jelentős módosítással
        értesíteni fogjuk az érintetteket. A változások hatályba lépését
        követően a felhasználóknak lehetőséget kell adni arra, hogy újra
        hozzájáruljanak az adatkezeléshez.
      </p>
      <p>
        <h2>Jogszabályi alap:</h2> Az adatkezelést az 2011. évi CXII. törvény az
        információs önrendelkezési jogról és az információszabadságról
        (Infotv.), valamint az Európai Parlament és Tanács 2016/679 Rendelete
        (GDPR) alapján végzik.
      </p>
      <p>
        <h2>Adatkezelő:</h2> [VÁLLALAT NEVE], székhelye: [SZÉKHELYES CÍM]
      </p>
      <p>
        <h2>Adattovábbítás:</h2> Az adatokat kizárólag az [VÁLLALAT NEVE] és az
        odlalon regisztrált munkaadóinak csoportjának tagjai részére
        továbbíthatjuk, akik kötelesek titoktartást vállalni.
      </p>
      <p>
        <h2>Adatvédelem:</h2> A vállalkozás megtesz minden olyan intézkedést,
        amely az adatok biztonságát garantálja, beleértve a fizikai és logikai
        védelmi intézkedéseket, valamint a hozzáférés-ellenőrzést.
      </p>
      <p>
        <h2>Érintettek jogai:</h2> Az érintett jogosult arra, hogy kérelmezze az
        Önét érintő adatot ellenőrizze, módosítsa, törlését kezdeményezze vagy
        tiltakozzon az adatkezelés ellen. A kérelmeket a [VÁLLALAT NEVE]
        elérhetőségein keresztül lehet benyújtani.
      </p>
      <p>
        <h2>Sütik és nyomkövetés:</h2> A vállalkozás név és profilkép, valamint
        e-mail címet tárol sütikben az egyszerűbb hozzáférések érdekében. Ezeket
        nem osztjuk meg harmadik felekkel vagy továbbítjuk más oldalakra.
      </p>
      <p>
        <h2>Cégadatok:</h2> A cég adatvédelmi felelőse: [CÉG ADATVEDELMI
        FELELŐSE]. A kapcsolattartás során kereshetnek bennünket a [VÁLLALAT
        NEVE] elérhetőségein keresztül.
      </p>
      <h2>Frissítések és változtatások</h2>
      <p>
        A tájékoztató időnként frissülhet. Minden jelentős módosítással
        értesíteni fogjuk az érintetteket. A változások hatályba lépését
        követően a felhasználóknak lehetőséget kell adni arra, hogy újra
        hozzájáruljanak az adatkezeléshez.
      </p>
      <br></br> <br></br> <br></br>
      <button onClick={navigateToHome} className="back-button">
        Vissza a főoldalra
      </button>
      <br></br> <br></br> <br></br>
    </>
  );
};

export default DataPrivacy;
